<div class="warp-card">
   <div *ngFor="let t of templates$()?.result">
      <que-card class=" pointer" [questionnaire]="t">
         <img class="print-screan-img" [src]="t.templateImage">
         <div logo class="logo-wrapper" *ngIf="t.definitions.logo">
            <div class="logo">
               <img src="{{t.definitions.logo}}" class="logoImg" />
            </div>
         </div>
         <img class="smartImg" smartImg src="../../../assets/images/types/smart-black.svg" *ngIf="t.sourceId" />
         <div name class="wrap-name2">
            <p name class="name ellipsis xxx">{{t.name}}</p>
            <div class="tooltip-abs" *ngIf="t.name">
               <p>{{t.name}}</p>
            </div>
            <span class="api-exposure-badge" *ngIf="!isDisplayUser$() && t?.definitions?.apiExposureEnabled === true" title="API Exposure">
               <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
               </svg>
               API
            </span>
            <span class="exposure-badge exposure-badge--unauthorized" *ngIf="!isDisplayUser$() && t?.isUnauthorized" title="Unauthorized">
               <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
               </svg>
            </span>
            <span class="exposure-badge exposure-badge--issendall " *ngIf="!isDisplayUser$() && t?.distributionDetails?.isSendAll"
               title=" Send All">
               <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
               </svg>
            </span>
         </div>
         <p translate class="start-content" startText>cards.createdIn</p>
         <p startDate class="startDate start-content">{{t.distributionDate| queDate}}</p>
         <que-questionnaire-status *ngIf="!isDisplayUser$() else statusToUser"
            [status]="t.status"></que-questionnaire-status>
         <ng-template #statusToUser>
            <que-questionnaire-status-to-user [status]="t?.statusToUser"></que-questionnaire-status-to-user>
         </ng-template>
      </que-card>
   </div>
   <div class="template-loading" *ngIf="loadingExtra$()"></div>
   <div class="template-loading" *ngIf="loadingExtra$()"></div>
   <div class="template-loading" *ngIf="loadingExtra$()"></div>
   <div class="template-loading" *ngIf="loadingExtra$()"></div>
   <div class="template-loading" *ngIf="loadingExtra$()"></div>
</div>